import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Navigation } from './Navigation';
import './Header.css';

export const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="header">
      <div className="header__container container">
        <Link to="/" className="header__logo">
          <img src="/logo.png" alt="VALORANTZ" className="header__logo-img" />
          <h1 className="header__logo-text">VALORANTZ</h1>
        </Link>

        <Navigation
          isMobileMenuOpen={isMobileMenuOpen}
          onToggleMobileMenu={toggleMobileMenu}
        />
      </div>
    </header>
  );
};
